<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijschool in Eindhoven zoeken?</h1>
      <p>
        Wil je graag rijlessen nemen, maar weet je niet goed voor welke
        rijschool in Eindhoven je moet kiezen? Rijscholenvergelijker.nl helpt je
        op weg. Hier kan iedereen namelijk gratis informatie aanvragen van
        meerdere rijscholen in zijn of haar eigen regio. Het maakt niet uit welk
        rijbewijs je wilt gaan halen, want van rijbewijs B tot en met rijbewijs
        DE zorgen wij voor offertes van rijscholen in Eindhoven. Waar kun je
        terecht voor het laagste uurtarief? Wie heeft het hoogste
        slagingspercentage? Laat je goed informeren door iedere rijschool en
        zorg er met een weloverwogen keuze voor dat je uiteindelijk euro’s
        bespaart op je rijlessen!
      </p>

      <h2>Gratis, simpel, effectief</h2>
      <p>
        Het aanvragen van offertes via deze website is niet alleen helemaal
        gratis, maar ook nog eens gebeurd binnen een minuut. Bovendien zit je na
        de aanvraag helemaal nergens aan vast én hoef je niet met iedere
        rijschool in Eindhoven contact op te nemen. Door alle
        <nuxt-link to="/"> rijscholen </nuxt-link> in de omgeving goed met
        elkaar te vergelijken, kun je alles bij elkaar tot honderden euro’s
        besparen. Kortom: alleen maar voordelen! Kies dus voor de mogelijkheid
        op Rijscholenvergelijker.nl om de informatie van verschillende
        rijscholen in Eindhoven tegen elkaar af te wegen en zorg ervoor dat je
        je rijbewijs binnen de kortste keren te pakken hebt!
      </p>

      <h2>Welke rijschool in Eindhoven is het beste?</h2>
      <p>
        Voor iedereen is de definitie van een goede rijschool anders. Denk er
        dus goed over na welke zaken jij belangrijk vindt en informeer ernaar
        bij elke rijschool in Eindhoven waarmee je in contact komt. Een paar
        algemene adviezen: vraag behalve het uurtarief ook naar het
        slagingspercentage en het gemiddeld aantal lessen dat kandidaten bij de
        betreffende rijschool nodig hebben voordat ze slagen voor hun
        praktijkexamen. Veel succes!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Rijschool in Eindhoven zoeken? Rijscholenvergelijker.nl helpt je!',
      headDescription:
        'Als je op zoek bent naar een goede en betaalbare rijschool in Eindhoven, helpt Rijscholenvergelijker.nl je verder. Hier vergelijk je gratis offertes!',
    }
  },
}
</script>
